import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import ChartPageErrorBoundary from "./ChartPageErrorBoundary";
import WithCart from "../Cart/WithCart";
import { useAsyncThrow } from "../../helpers/throw.js";
import {
  BrowserRouter as Router,
  useNavigate,
  useLocation,
} from "react-router-dom";


import axios from 'axios';

import parse from 'html-react-parser';

import { promoAnalytics } from '../../helpers/analytics.js';
import Form from "../Form/Form";
import StickyHeader from "../StickyHeader/index";

function MakeForm(props){

  const [chartMarkup, setChartMarkup] = useState('');
  const [chartTableMarkup, setChartTableMarkup] = useState('');

  const asyncThrow = useAsyncThrow();

  const chartRef = useRef(null)

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if( location.search ){
      setChart(location.search);
    }
  }, [location]);

  const setChart = (queryString) => {
    axios.get('/requestchart'+queryString)
      .then(response=>{
        setChartMarkup( response.data.chart );
        setChartTableMarkup( response.data.table );
        if( chartRef.current && chartRef.current.scrollIntoView ){
          chartRef.current.scrollIntoView();
        }
      }).catch(err => {
        // TODO, improve this- do retry
        asyncThrow(new Error(err));
      });
  };

  const submit = ({
        formattedDateTime,
        placeId,
        placeDesc,
        latitude,
        longitude,
        minute,
        hour,
        day,
        month,
        year,
        dontKnowTime
    }) => {

    // translate these into the ruby params
    const chart = {
      place_id: placeId,
      formatted_place: encodeURIComponent(placeDesc),
      formatted_date: formattedDateTime,
      latitude,
      longitude,
      minute,
      hour,
      day,
      // js month dates start at 0
      month:month+1,
      year,
      dont_know_time:dontKnowTime
    };

    let queryString = Object.keys(chart).map(key => key + '=' + chart[key]).join('&');

    queryString = '?'+queryString;

    navigate({
      search: queryString
    });

    setChart(queryString);
  };

  const showChartContent = (chartMarkup !== '' && chartTableMarkup !== '');

  let shopUrl = '';
  if( location.search ){
    shopUrl = `/shop/pendant/brass/small${location.search}`;
  }

  return(<>
    <Form mapKey={GOOGLEMAPS_KEY} submit={submit}/>
    <StickyHeader show={showChartContent}>
      <div className="d-flex justify-content-evenly sticky-inner-content">
        <div className="chart-offer-left">
          <p className="chart-offer-text">Create a necklace from this chart✨</p>
          <p>
            <a
              className="btn ptn-primary btn-light"
              href={shopUrl}
              onClick={()=>promoAnalytics('chart-to-shop')}
            >
                PREVIEW YOURS NOW
            </a>
          </p>
        </div>
        <div className="promo-img-cont">
        </div>
      </div>
    </StickyHeader>
    <div className="row chart-data-container" ref={chartRef}>
    {showChartContent &&
      <>
        <div className="col-12 chart-markup-container">
          {parse(chartMarkup)}
        </div>
        {parse(chartTableMarkup)}
      </>
    }
    </div>
  </>);
}

function ChartPage(props){
  return (<>
      <Router>
        <MakeForm/>
      </Router>
    </>);
}

function ChartPageWithErrorBoundary(props){

  return (<ChartPageErrorBoundary>
    <WithCart {...props}>
      <ChartPage {...props} />
    </WithCart>
  </ChartPageErrorBoundary>)
}

export default ChartPageWithErrorBoundary;
